/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import { YES_NO_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

const items = [
  { id: YES_NO_VALUES.YES, name: 'Yes', value: YES_NO_VALUES.YES },
  { id: YES_NO_VALUES.NO, name: 'No', value: YES_NO_VALUES.NO },
];

type Props = {|
  form: string,
  name: string,
  includeEmptyOption: boolean,
  inputClassName: string,
|};

const YesNoSelectMenu = ({
  form,
  name,
  includeEmptyOption,
  inputClassName,
}: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={items}
    id={name}
    name={name}
    inputClassName={classNames('custom-select', inputClassName)}
    includeEmptyOption={includeEmptyOption}
  />
);

export default YesNoSelectMenu;
